export function isDefrentNotificationData (oldData, newData) {
    return oldData.length !== newData.length || JSON.stringify(oldData) !== JSON.stringify(newData);
}
// if(oldData.length!==newData.length) return true;
// const oldid = (oldData || []).map(i=> i.id)
// const newid = (newData || []).map(i=>i.id)
// const oldtitle = (oldData || []).map(i=> i.title)
// const newtitle = (newData || []).map(i=>i.title)
// const oldbody = (oldData || []).map(i=> i.body)
// const newbody = (newData || []).map(i=>i.body)
// const oldurl = (oldData || []).map(i=> i.url)
// const newurl = (newData || []).map(i=>i.url)
// const oldis_read = (oldData || []).map(i=> i.is_read)
// const newis_read = (newData || []).map(i=>i.is_read)
// const oldread_at = (oldData || []).map(i=> i.read_at)
// const newread_at = (newData || []).map(i=>i.read_at)
// const oldupdated_at = (oldData || []).map(i=> i.updated_at)
// const newupdated_at = (newData || []).map(i=>i.updated_at)

// return JSON.stringify(newid)!==JSON.stringify(oldid) ||
// JSON.stringify(oldbody)!==JSON.stringify(newbody) ||
// JSON.stringify(oldurl)!==JSON.stringify(newurl) ||
// JSON.stringify(oldis_read)!==JSON.stringify(newis_read) ||
// JSON.stringify(oldread_at)!==JSON.stringify(newread_at) ||
// JSON.stringify(oldupdated_at)!==JSON.stringify(newupdated_at) ||
// JSON.stringify(newtitle)!==JSON.stringify(oldtitle);